import { renderDownloadThrobber } from "@utils/common";

// Start the throbber immediately!
renderDownloadThrobber(
  document.getElementById("throbber") as HTMLCanvasElement | null,
);
